export const CircleWarningYellow = (): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    fill="none"
    viewBox="0 0 14 14"
  >
    <g>
      <path
        stroke="#FFBE16"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M7 4.6V7m0 2.4h-.006M1 7a6 6 0 1112 0A6 6 0 011 7z"
      />
    </g>
  </svg>
);
